<mat-icon
    [style.width]="width"
    [style.height]="height"
    [class.cursor]="cursor"
    [color]="color"
    [class]="size"
    fontSet="mb"
    [fontIcon]="'icon-mb-' + icon"
    [ngStyle]="{ color: svgColor }"
></mat-icon>
